document.addEventListener('DOMContentLoaded', function () {
  const carouselSection = document.querySelector('.product-carousel-swiper');

  if (carouselSection) {
    setTimeout(() => {
      // Get the swiper instance from the DOM element
      const swiperInstance = carouselSection.swiper;

      if (swiperInstance) {
        carouselSection.addEventListener('mousemove', (e) => {
          const rect = carouselSection.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const sectionWidth = rect.width;

          // Left half of the entire section shows left arrow, right half shows right arrow
          if (x < sectionWidth / 2) {
            carouselSection.style.cursor = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="white"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>'), auto`;
          } else {
            carouselSection.style.cursor = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="white"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>'), auto`;
          }
        });

        carouselSection.addEventListener('click', (e) => {
          const rect = carouselSection.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const sectionWidth = rect.width;

          // Left half goes to previous slide, right half goes to next slide
          if (x < sectionWidth / 2) {
            swiperInstance.slidePrev();
          } else {
            swiperInstance.slideNext();
          }
        });

        carouselSection.addEventListener('mouseleave', () => {
          carouselSection.style.cursor = 'default';
        });
      } else {
      }
    }, 100);
  } else {
  }

  const megaMenus = document.querySelectorAll('details.mega-menu');

  megaMenus.forEach((details) => {
    const summary = details.querySelector('summary');
    let closeTimeout;

    if (summary) {
      details.addEventListener('mouseenter', () => {
        if (closeTimeout) {
          clearTimeout(closeTimeout);
        }
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 100);
      });

      summary.addEventListener('click', (e) => {
        if (e.target === summary || e.target.closest('summary') === summary) {
          e.preventDefault();
        }
      });
    }
  });
});
